const uiConfig = require('./ui.config.json');

export const getUiConfig = (name) => uiConfig[name];



// WEBPACK FOOTER //
// ./src/lib/ui.js